import { Component } from '@angular/core';

@Component({
  selector: 'app-modal-oferta-cookie',
  templateUrl: './modal-oferta-cookie.component.html',
  styleUrls: ['./modal-oferta-cookie.component.scss']
})
export class ModalOfertaCookieComponent {
 public isModalOfertaCookieShow: boolean = false;
 public isDarkBackground: boolean = false;

  openModalCookieShow() {
    this.isModalOfertaCookieShow = true;
    this.isDarkBackground = true;
}

  closeModal() {
    this.isModalOfertaCookieShow = false;
    this.isDarkBackground = false;
  }
}
